function SuccessBtn({ onClick, text, loading = false }) {
  return (
    <button className="btn btn-success w-100" disabled={loading} onClick={onClick}>
        {loading ? <><i className="fa-solid fa-spinner fa-spin"></i> Loading...</> : text}
    </button>
  );
}

export default SuccessBtn;
